// pages/faq.js
import {
	Box,
	Text,
	VStack,
	Accordion,
	AccordionItem,
	AccordionButton,
	AccordionPanel,
	Flex,
	Heading,
	useBreakpointValue,
	useDisclosure
} from '@chakra-ui/react';
import Layout from '../components/layouts/main';
import { ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons';
import { useState } from 'react';
import { motion } from 'framer-motion';

const MotionHeading = motion(Heading);

const questions = [
	{
		question: "What is ScrollStat?",
		answer: "ScrollStat is a project designed to analyze data from the Scroll blockchain and assist users in understanding their current ranking and status. It provides insights into where a user's wallet stands in the ranking system, helping users keep track of their performance and progress."
	},
	{
		question: "What data is stored by ScrollStat?",
		answer: "ScrollStat does not store or save any requests or data sent by users. The project is designed with privacy in mind, ensuring that all interactions and queries are processed in real-time without retention of personal or query-related information."
	},
	{
		question: "Is it safe to check statistics through ScrollStat?",
		answer: "Yes, it is safe to check your statistics through ScrollStat. The project is built with a focus on security and privacy, ensuring that user data and interactions are handled safely and securely."
	},
	{
		question: "I minted a key, but the additional features didn't appear",
		answer: "Try refreshing the page. Please check your wallet connection.It's important that the wallet connected is the one used to mint the key. If you're still experiencing an issue, please reach out to us via the contact form with details about your problem."
	},

	{
		question: "Where does ScrollStat get its data from?",
		answer: "ScrollStat retrieves its data directly from the Scroll blockchain. This ensures that the information provided is accurate and up-to-date, as it is sourced from the blockchain's native data without any intermediate processing."
	},
	{
		question: "Where are the \"recent checks\" stored ?",
		answer: "The \"recent checks\" are stored in your browser's local storage. This data is kept on your device to enhance your browsing experience and is accessible only from your device."
	},
	{
		question: "How does ScrollStat track user engagement?",
		answer: "ScrollStat tracks user engagement solely through Google Analytics. This helps us understand the number of users interacting with the service and improve the overall user experience. We do not collect any personal data beyond what is required for analytics purposes."
	},
	{
		question: "Will badge counts be added for users?",
		answer: "Yes, badge counts will be added in the future. We plan to introduce a system where users can view and track the number of badges they have accumulated. This feature aims to enhance user engagement and provide more detailed insights into user achievements."
	},
];

const FAQPage = () => {
	const { isOpen, onToggle } = useDisclosure();
	const [openIndex, setOpenIndex] = useState(null);
	const isMobile = useBreakpointValue({ base: true, md: false });

	const handleToggle = (index) => {
		setOpenIndex(openIndex === index ? null : index);
	};

	return (
		<Layout>
			<Box padding={isMobile ? 4 : 8} color="black" display="flex" justifyContent="center">
				<Box maxWidth="700px" width="100%">
					<VStack spacing={6} align="center">
						<MotionHeading
							fontSize="clamp(1.5em, 2.8vw, 2.4em)"
							initial={{ opacity: 0, y: 20 }}
							animate={{ opacity: 1, y: 0 }}
							transition={{ duration: 1 }}
							textAlign={"center"}
							m={!isMobile ? 6 : 1}
						>
							FAQ
						</MotionHeading>
						<Flex direction="column" w="100%">
							<Accordion allowMultiple={false} w="100%">
								{questions.map((item, index) => (
									<AccordionItem key={index}>
										<h2>
											<AccordionButton
												bg={openIndex === index ? '#FF684B' : 'transaparent'}
												color={'black'}
												_hover={{ bg: '#FF684B', color: 'black' }}
												onClick={() => handleToggle(index)}
												py={isMobile ? 2 : 4}
												px={isMobile ? 3 : 6}
											>
												<Box as='span' flex='1' textAlign='left'>
													{item.question}
												</Box>
												{openIndex === index ? (
													<ChevronUpIcon boxSize={6} />
												) : (
													<ChevronDownIcon boxSize={6} />
												)}
											</AccordionButton>
										</h2>
										<AccordionPanel pb={4} display={openIndex === index ? "block" : "none"} px={isMobile ? 2 : 4}>
											<Text fontSize={isMobile ? "sm" : "md"}>
												{item.answer}
											</Text>
										</AccordionPanel>
									</AccordionItem>
								))}
							</Accordion>
						</Flex>
					</VStack>
				</Box>
			</Box>
		</Layout>
	);
};

export default FAQPage;
